import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import { handleLoginModal, logoutApp } from '../../Redux/Actions/auth';
import { MEDIAPATH } from '../../Redux/Actions/config';
import { isIIMSirMauriEmail, isValidString } from '../../helper';


const Navigation = () => {
  const dispatch = useDispatch();
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const { user } = useSelector(state => state.auth);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  
  const closeNav = () => setIsNavCollapsed(true);

  const handleLogin = () => {
    dispatch(handleLoginModal(true));
    closeNav();
  }

  const handleLogout = () => {
    dispatch(logoutApp());
    closeNav();
    setTimeout(() => {
      window.location.href = "/home";
    }, 1000);
  }

  return (
    <nav id="home-page" className="navbar navbar-header navbar-expand-sm navbar-dark p-0 shadow">
      <div className="container">
        <Link className="navbar-brand p-0" to="/">
          <img src="/images/logo.svg" alt="logo" />
        </Link>
        <button 
          className="navbar-toggler" 
          id="toggler" 
          type="button" 
          onClick={handleNavCollapse}
          aria-expanded={!isNavCollapsed}
        >
          <span className="navbar-toggler-icon">
            <div className="bar1"></div>
            <div className="bar2"></div>
            <div className="bar3"></div>
          </span>
        </button>
        <div 
          className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse justify-content-lg-end`} 
          id="mynavbar"
        >
          <ul className="navbar-nav col-lg-4">
            <li className="nav-item">
              <Link className="nav-link" to="/job-board" onClick={closeNav}>Job Openings</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={closeNav}>My Profile</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/programs" onClick={closeNav}>Upskill</Link>
            </li>
          </ul>
          {isAuthenticated ?
            <ul className="navbar-nav">
              <li>
                <Link className="dropdown-item" to="#" onClick={handleLogout}>
                  <img src='./svg/logout.svg' alt='' className='me-2' />
                  Logout
                </Link>
              </li>
            </ul>
            : <Link to="#" onClick={handleLogin} className="contact nav-link">
                {/* <img src='./svg/logout.svg' alt='' className='me-2'/> */}
                Login
              </Link>
          }
        </div>
      </div>
    </nav>
  )
}

export default Navigation
